import React, { Fragment, Component } from 'react';

import Core from './../../Core/Core';
import ErrorManager from './../../Core/ErrorManager';

import CarModal from './CarModal';

class Cars extends Component
{
    constructor(props)
    {
        super(props);

        this.edit = this.edit.bind(this);
        this.delete = this.delete.bind(this);
        this.dateDiff = this.dateDiff.bind(this);

        this.durations = {
            "an(s)": 31536000,
            "mois": 2592000,
            "semaine(s)": 604800,
            "jour(s)": 86400,   
        };
    }

    edit(id)
    {
        window.location.href = "/car/edit/"+id
    }

    delete(id)
    {
        if(!window.confirm("Etes-vous sûr de vouloir supprimer cet élément ?"))
            return;
        Core.Instance.Request(Core.Address+"Car/"+id, null, "DELETE").then((json)=> {
            ErrorManager.Instance.Info("L'élément a bien été supprimé.");
            window.location.reload();
        });
        
    }

    dateDiff(timestamp) {
        let res = "";
        for(let key in this.durations) {
            let value = Math.floor(timestamp / this.durations[key]);
            if(value > 0){
                res += value + " " + key + " ";
                timestamp -= value * this.durations[key];
            }
        }
        return res.trim();
    }
    

    render()
    {
        
        let cars = this.props.cars == null ? [] : 
        this.props.cars.map((e, index) => {

            let date_first_code = null;
            if(e.date_first_code != null)
            {
                date_first_code = new Date(e.date_first_code*1000);
                date_first_code = ("0"+date_first_code.getDate()).slice(-2)+"/"+("0"+(date_first_code.getMonth()+1)).slice(-2)+"/"+date_first_code.getFullYear();

            }
            let date_end = null;
            if(e.date_end != null)
            {
                date_end = new Date(e.date_end*1000);
                date_end = ("0"+date_end.getDate()).slice(-2)+"/"+("0"+(date_end.getMonth()+1)).slice(-2)+"/"+date_end.getFullYear();
            }
            let date_delivery = null;
            if(e.date_delivery != null)
            {
                date_delivery = new Date(e.date_delivery*1000);
                date_delivery = ("0"+date_delivery.getDate()).slice(-2)+"/"+("0"+(date_delivery.getMonth()+1)).slice(-2)+"/"+date_delivery.getFullYear();
            }
            let date_order = null;
            if(e.date_order != null)
            {
                date_order = new Date(e.date_order*1000);
                date_order = ("0"+date_order.getDate()).slice(-2)+"/"+("0"+(date_order.getMonth()+1)).slice(-2)+"/"+date_order.getFullYear();
            }
            //Date théorique fin DIAC
            let date_end_diac = null;
            if(e.date_start_diac != null && e.diac_duration){
                let start = new Date(e.date_start_diac*1000);
                date_end_diac = start.setMonth(start.getMonth()+e.diac_duration);
                date_end_diac = new Date(date_end_diac);
                date_end_diac = ("0"+date_end_diac.getDate()).slice(-2)+"/"+("0"+(date_end_diac.getMonth()+1)).slice(-2)+"/"+date_end_diac.getFullYear();
            }
            //Date théorique fin CtSce
            let date_end_ctsce = null;
            if(e.date_start_ctsce != null && e.duration_ctsce){
                let start = new Date(e.date_start_ctsce*1000);
                date_end_ctsce = start.setMonth(start.getMonth()+e.duration_ctsce);
                date_end_ctsce = new Date(date_end_ctsce);
                date_end_ctsce = ("0"+date_end_ctsce.getDate()).slice(-2)+"/"+("0"+(date_end_ctsce.getMonth()+1)).slice(-2)+"/"+date_end_ctsce.getFullYear();
            }
            //Date gravage
            let date_engraving = null;
            if(e.date_engraving != null && e.date_engraving)
            {
                date_engraving = new Date(e.date_engraving*1000);
                date_engraving = ("0"+date_engraving.getDate()).slice(-2)+"/"+("0"+(date_engraving.getMonth()+1)).slice(-2)+"/"+date_engraving.getFullYear();
            }
            //DATE PROBABLE PROCHAIN ACHAT
            let date_next_purchase = null;
            if(e.avg_duration)
            {
                date_next_purchase = new Date((e.date_delivery + e.avg_duration)*1000);
                date_next_purchase = ("0"+date_next_purchase.getDate()).slice(-2)+"/"+("0"+(date_next_purchase.getMonth()+1)).slice(-2)+"/"+date_next_purchase.getFullYear();
            }
            return (
            <Fragment key={ e.id }>
                <tr>
                    <td>{ e.brand ? e.brand : '/' }</td>
                    <td>{ e.model ? e.model : '/' }</td>
                    <td>{ e.vin ? e.vin : '/' }</td>
                    <td>{ date_first_code ? date_first_code: '/' }</td>
                    <td><a target="_blank" href={ "https://dcs.renault.com/icm/jsp/ServletLogin?VIN="+e.vin+"&KM=1" }>{ e.code ? e.code : '/' }</a></td>
                    <td>{ date_order ? date_order : '/'}</td>
                    <td>{ date_delivery ? date_delivery : '/' }</td>
                    <td>{ e.shortname ? e.shortname : '/'}</td>
                    <td>{ e.conseilor ? e.conseilor : '/' }</td>
                    <td>{ e.order_service ? e.order_service : '/' }</td>{/* VN ou VO selon import DCSnet */}
                    <td>{ date_end ? date_end : '/' }</td>
                    <td>{ e.diac_financial_product ? e.diac_financial_product : '/'}</td>
                    <td>{ date_end_diac ? date_end_diac : '/' }</td>
                    <td>{ e.product_detail ? e.product_detail : '/' }</td>
                    <td>{ date_end_ctsce ? date_end_ctsce : '/' }</td>
                    <td>{ date_engraving ? date_engraving : '/' }</td>
                    <td>{ e.engraving ? e.engraving : '/' }</td>
                    <td>{ e.avg_duration ? this.dateDiff(e.avg_duration) : '' }</td>
                    <td>{ date_next_purchase ? date_next_purchase : '' }</td>
                    <td className="d-flex align-items-end">
                        <span className="far fa-eye text-secondary" data-toggle="modal" data-target={ "#cars"+e.id } />
                        {
                            this.props.editing == true && 
                            <Fragment>
                                <span className='fas fa-edit ml-2' onClick={ (ev) => { ev.preventDefault();this.edit(e.id) }}/>
                                <span className='far fa-trash-alt ml-2' onClick={ (ev) => { ev.preventDefault();this.delete(e.id) } }/>
                            </Fragment>
                        }
                    </td>                   
                </tr>
                <CarModal index={e.id} car={e}/>
            </Fragment>
            );
        });

        return (
            <div>
                <table className="table table-striped">
                    <thead className="">
                        <tr>
                            <th>Marque</th>
                            <th>Modèle</th>
                            <th>VIN</th>
                            <th>Date 1ère Imma.</th>
                            <th>Immatriculation</th>
                            <th>Date commande DCSnet</th>
                            <th>Date livraison DCSnet</th>
                            <th>Concession commande</th>
                            <th>Vendeur commande</th>
                            <th>Service commande</th>
                            <th>Date fin relation MAEVA</th>
                            <th>Produit financier DIAC</th>
                            <th>Date théorique fin DIAC</th>
                            <th>Produit détaillé CtSce</th>
                            <th>Date théorique CtSce</th>
                            <th>DATE GRAVAGE</th>
                            <th>GRAVAGE</th>
                            <th>DUREE DE DETENTION MOYENNE</th>
                            <th>DATE PROBABLE PROCHAIN ACHAT</th>
                            <th></th>
                        </tr>
                    </thead>
                    <tbody className="">
                        { cars }
                    </tbody>
                </table>
            </div>
        );
    }
}

export default Cars;



// WEBPACK FOOTER //
// ./src/Components/Car/Cars.js